module.exports = __webpack_public_path__ + "img/Cairo2.7a643478.jpg";